import { BallTriangle, ThreeDots } from "react-loader-spinner"

export const Loader = () => {
    return (
        <div className="d-flex justify-content-center vertical-align">
            <BallTriangle
                height={100}
                width={100}
                radius={5}
                className="text-center"
                color="#0046ad"
                ariaLabel="ball-triangle-loading"
                wrapperStyle={{animation: 'fade-in 3s'}}
                wrapperClass=""
                visible={true}
            /> 
        </div>
    )
}

export const DotsLoader = () => {
    return (
        <div className="d-flex justify-content-center vertical-align">
            <ThreeDots
                height={100}
                width={100}
                radius={5}
                className="text-center"
                color="#0046ad"
                ariaLabel="ball-triangle-loading"
                wrapperStyle={{animation: 'fade-in 3s'}}
                wrapperClass=""
                visible={true}
            /> 
        </div>
    )
}